import {Component, ComponentFactoryResolver, OnInit, ViewChild} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';
import {FieldValueDirective} from '../../directives/field-value.directive';
import {FieldFormService} from '../../services/field-form/field-form.service';
import {EFieldType} from '../../../form-builder/enums/e-field-type.enum';
import {FieldEditedEvent} from '../../../form-renderer/interfaces/FieldEditedEvent';

@Component({
  selector: 'app-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.css']
})
export class FieldComponent extends FieldComponentAbstract implements OnInit {

  @ViewChild(FieldValueDirective) fieldValueContainer: FieldValueDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private fieldFormService: FieldFormService) {
    super();
  }

  ngOnInit(): void {
    this.loadFieldComponent();
  }

  /**
   * Dynamically load the proper field component into the fieldValueContainer.
   */
  loadFieldComponent() {
    const type = this.fieldValue.field.type;
    const readonly = !this.editable || this.fieldValue.field.readonly;
    const component = this.createComponentInstance(type, readonly);
    this.configureComponentInstance(component, readonly);
  }

  /**
   * Connect all the bindings of the given component to this component
   * @param {FieldComponentAbstract} component
   * @param {boolean} readonly
   */
  configureComponentInstance(component: FieldComponentAbstract, readonly: boolean) {
    component.fieldValue = this.fieldValue;
    component.fieldValueChange.subscribe((updatedFieldValue) => this.fieldValue = updatedFieldValue);
    component.form = this.form;
    component.edited.subscribe((e: FieldEditedEvent) => this.onChange(e.field));
    if (readonly)
      component.editable = false;
  }

  /**
   * Instantiates the proper field component for the given type.
   * @param {EFieldType} type
   * @param {boolean} readonly
   * @returns {FieldComponentAbstract}
   */
  createComponentInstance(type: EFieldType, readonly: boolean): FieldComponentAbstract {
    const componentClass = readonly ?
      this.fieldFormService.getReadonlyFieldComponent(type) :
      this.fieldFormService.getFieldComponent(type);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentClass);
    const fieldValueRef = this.fieldValueContainer.viewContainerRef.createComponent(componentFactory);
    return <FieldComponentAbstract>fieldValueRef.instance;
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/field/field.component.ts